import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NotificationService } from '../../../../../../components/notification/services/notification.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ScheduleServices } from '../../../../core/models/schedule/schedule-services.model';
import {
  CurrencyService,
} from '../../../../core/services/currency/currency.service';
import { ScheduleService } from '../../../../core/services/schedule/schedule.service';
import { QUOTATION } from '../../../../utils/quotation/constants/constants';
import { DriverInformationModel } from '../../../../core/models/schedule/driver-information.model';
import { firstValueFrom, takeUntil } from 'rxjs';
import {
  FORD_PROTECT_STATUS_ACTIVE,
  FORD_PROTECT_STATUS_FINISHED,
  formatTime,
  SESSION_FORD_PROTECT,
  isFordProtectValid
} from '../../../../utils/utils';
import { VehicleService } from '../../../../core/services/vehicle/vehicle.service';
import { FordProtect } from '../../../../core/models/vehicle/ford-protect.model';
import {
  DISCOUNT_TYPE,
  FordProtectPlanType,
} from '../../../../utils/constants';
import { QuotationScheduleDetailVO } from '../../../../core/models/quotation/quotation-schedule-detail.model';
import { QuotationService } from '../../../../core/models/quotation/quotation-service.model';
import { QuotationServiceCampaignModel } from '../../../../core/models/quotation/quotation-service-campaign.model';
import { NgIf, NgFor, UpperCasePipe, TitleCasePipe, DatePipe, JsonPipe } from '@angular/common';
import { CardAddressComponent, DriverInformationComponent, IFeatureToggle } from '@agenda-customer-ui/shared';
import { IUserProfileResponse } from '@core/interface';
import { FeatureToggleCodes, FooterService, NewPushNotificationService, NewScheduleService, NotificationsAPIService, QuotationsService, SessionService, UserService, } from '@agenda-customer-ui/data-access';
import { DealerService } from '../../../../core/services/dealer/dealer.service';
import { FirstLetterCasePipe } from '../../../pipes/firstLetterCase.pipe';
import { FdsCurrencyPipe } from '../../../pipes/currency/currency-status.pipe';
import { DecreaseNamePipe } from '../../../pipes/name/decreaseName.pipe';
import { HourPipe } from '../../../pipes/hour/hour.pipe';
import { DialogComponent } from '@components/atoms';

import { ButtonLibComponent } from '@components/atoms';
import { COUNTRY_CODE, HTTP_CODE, PaymentStatusEnum, SchedulingModalityEnum, StorageKeys, TypeResourceMessage } from '@core/enums';
import { IFormatedServiceBudget, IOpenSchedule, IPayloadDriver, IRecallFromQuotationApi, IVehicleFromUsers } from '@core/interface';
import { ActivatedRoute, Router } from '@angular/router';
import { isRecall } from '@core/utils';
import { CardDisplayItemsBudgetComponent } from '@components/molecules';
import { PaymentMethodItemComponent } from './payment-method-item/payment-method-item.component';
import { CalcService, RulesService, UserService as CoreUserService, MyGarageService } from '@core/services';
import { CurrencyOSRPipe } from '@core/pipes';
import { RoutesPath } from '@core/enums';
import { SharedModuleLib } from '../../../../../../shared.module';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  providers: [CurrencyService, DatePipe, VehicleService, DealerService, NotificationsAPIService, ScheduleService],
  standalone: true,
  imports: [
    NgIf,
    CardAddressComponent,
    NgFor,
    DialogComponent,
    ButtonLibComponent,
    SharedModuleLib,
    UpperCasePipe,
    TitleCasePipe,
    TranslateModule,
    HourPipe,
    DecreaseNamePipe,
    FdsCurrencyPipe,
    FirstLetterCasePipe,
    DriverInformationComponent,
    CardDisplayItemsBudgetComponent,
    PaymentMethodItemComponent
  ],
})
export class DetailsComponent implements OnInit, OnChanges {
  readonly #calcService = inject(CalcService);
  readonly #rulesService = inject(RulesService);
  readonly #currencyOSR = inject(CurrencyOSRPipe);

  readonly #coreUserService = inject(CoreUserService);
  readonly #mygarageService = inject(MyGarageService);

  activatedRoute = inject(ActivatedRoute);
  newScheduleService = inject(NewScheduleService);
  quotationsService = inject(QuotationsService);
  router = inject(Router);
  userService = inject(UserService);

  @Input() isProjectStatus!: boolean;
  @Input() driveInformation!: DriverInformationModel;
  @Output() handleDetails = new EventEmitter<boolean>();
  @Output() reloadPage = new EventEmitter<boolean>();
  schedule!: IOpenSchedule;

  openReschedule = false;
  scheduleToCancel!: IOpenSchedule;
  loadingReschedule = false;
  loading = true;
  // TODO: trocar a interface antiga QuotationService para a nova IQuotationScheduleDetailVO para evitar replicação de codigo, com isso vamos eliminar codigo repedito e utilizar shared
  services: QuotationService[] = [];
  revision!: ScheduleServices;
  remoteExperienceService!: QuotationService;
  optionalServices: ScheduleServices[] = [];
  recall!: IRecallFromQuotationApi[];
  iolm!: QuotationService;
  iolmPrice = 0;
  vin = '';
  servicesOnRequest = false;
  servicesNoCost = false;
  scheduleDate: Date = new Date();
  servicesTotalPrice = 0;
  userProfile!: IUserProfileResponse;
  totalPrice = 0;
  loadingCancel = false;
  openModal = false;
  vehicle?: IVehicleFromUsers;
  fordProtect: FordProtect = new FordProtect();
  servicesOriginalPrice = 0;
  hasFordProtect = false;
  fordProtectPlanType = '';
  servicesHasPromotions = false;
  quotation!: QuotationScheduleDetailVO;
  revisionInfo!: QuotationService;
  offeredServices: any;
  onRequest = false;
  delivery!: QuotationService;
  servicesSubTotal = 0;
  revisionPrice = 0;
  subTotal = 0;
  pudModal = false;
  remoteExeperienceServiceID!: number;
  hasPriceInRevision = false;
  imageDriver = "../../../../../assets/img/Icon_Avatar.svg";
  loadingFP = false;
  getFordProtectCalled = new EventEmitter<void>();

  hasErrorPayment = false;
  hasApprovedPayment = false;
  hasOnlinePayment = false;
  onlinePaymentsFeatureEnabled = false;
  showPaymentPrices = false;
  openRescheduleUnavailable = false;

  // modalidade de agendamento
  modalityEnum = SchedulingModalityEnum;

  // motorista associado ao agendamento
  payloadDriver!: IPayloadDriver;
  hasDriverAssosiated = false;

  // variavel para armazenar os valores final do orçamento
  itemsTotal: Partial<IFormatedServiceBudget>[] = [];

  customerWaitingInDealer = false;

  constructor(
    private scheduleService: ScheduleService,
    private vehicleService: VehicleService,
    private notification: NotificationService,
    private translate: TranslateService,
    private pushService: NewPushNotificationService,
    public currencyService: CurrencyService,
    public dealerService: DealerService,
    private sessionService: SessionService,
    private footerService: FooterService
  ) {
    this.footerService.showFooter = false;
  }

  async ngOnInit(): Promise<void> {
    this.schedule = this.sessionService.getObject<IOpenSchedule>(StorageKeys.SCHEDULE_DETAILS);
    const user = await this.#coreUserService.loadUserProfile();
    if (user) {
      this.#coreUserService.saveUserProfile(user);
      this.userProfile = user;
    }

    this.payloadDriver = {
      advisor: this.schedule.advisorId,
      country: this.schedule.country,
      date: this.schedule.scheduleDate,
      dealer: this.schedule.dealerId,
      hour: this.schedule.scheduleHour,
      vin: this.schedule.vin,
    };

    this.#handlePayment();
    await this.dealerService.getDealerByIdCode(this.schedule.dealerId);
    this.vin = this.sessionService.getItem(StorageKeys.VIN_ACTIVE_DASHBOARD);
    this.scheduleToCancel = this.schedule;
    this.scheduleDate = new Date(this.schedule.scheduleDate);
    this.getVehicleData();
    this.getQuotation(this.schedule);

  }

  #generateInfosFromTotalBox() {
    const { countryTaxRate } = this.#rulesService.getRules();
    const hasTax = countryTaxRate && !this.onRequest;

    const finalPrice = this.subTotal ? this.subTotal : this.totalPrice;
    const priceWithoutTax = hasTax ? this.#calcService.calculateNetAmount(finalPrice, countryTaxRate) : undefined;

    const formatPrice = (price?: number) => {
      if (!this.onRequest && this.subTotal === 0) {
        return this.translate.instant('schedule.no-cost')
      }

      if (this.onRequest) {
        return this.translate.instant('schedule.on-request')
      }

      return this.#currencyOSR.transform(price, this.userProfile.languages?.preferredLanguage);
    }

    const itemFromTotalBox: Partial<IFormatedServiceBudget> = {
      finalPrice: formatPrice(finalPrice),
      appliedDiscount: this.subTotal !== this.totalPrice ? formatPrice(this.totalPrice) : undefined,
      priceWithoutTax: hasTax ? formatPrice(priceWithoutTax) : undefined,
      serviceName: this.translate.instant('resume.total-label'),
    };
    this.itemsTotal[0] = itemFromTotalBox;
  }

  #handlePayment() {
    const normalizedStatus = (this.schedule.paymentMethod?.[0]?.status ?? '').trim().toLowerCase() as PaymentStatusEnum;
    const approvedStatuses = [
      PaymentStatusEnum.APPROVED,
      PaymentStatusEnum.REFUNDED,
      PaymentStatusEnum.CHARGED_BACK,
      PaymentStatusEnum.AUTHORIZED,
    ];
    this.hasErrorPayment = normalizedStatus === PaymentStatusEnum.ERROR;
    this.hasApprovedPayment = approvedStatuses.includes(normalizedStatus);
    this.hasOnlinePayment = this.schedule.paymentMethod?.[0]?.online ?? false;
    this.onlinePaymentsFeatureEnabled = this.getFeatureToggleFromSession(FeatureToggleCodes.OSR_ONLINE_PAYMENTS_SCALE_UP);
    this.showPaymentPrices = this.getFeatureToggleFromSession(FeatureToggleCodes.OSR_ONLINE_PAYMENTS_SCALE_UP_V2);
  }

  getFeatureToggleFromSession(feature: FeatureToggleCodes): boolean {
    const featureToggles = this.sessionService.getObject<{ [key in FeatureToggleCodes]?: IFeatureToggle }>(StorageKeys.FEATURE_TOGGLE);
    return featureToggles?.[feature]?.active ?? false;
  }

  get visiblePaymentMethods() {
    return this.showPaymentPrices
      ? this.schedule.paymentMethod
      : this.schedule.paymentMethod?.slice(0, 1);
  }

  get canReschedule(): boolean {
    if (!this.hasOnlinePayment)  return this.schedule.rescheduleEnabled;
 
    if (this.isPaymentBlockedForReschedule()) return false;
 
    return this.schedule.rescheduleEnabled && this.onlinePaymentsFeatureEnabled;
  }
 
  isPaymentBlockedForReschedule(): boolean {
    const blockedStatuses = [PaymentStatusEnum.IN_PROCESS, PaymentStatusEnum.IN_MEDIATION];
    const currentStatus = this.schedule.paymentMethod?.[0]?.status?.toLowerCase() as PaymentStatusEnum;
    return blockedStatuses.includes(currentStatus);
  }

  ngOnChanges(): void {
    if (this.driveInformation && this.driveInformation.advisorDriverImage) {
      this.getUrlDriverImage(this.driveInformation.advisorDriverImage);
    }
  }

  async getVehicleData() {
    const vehicles = await this.#mygarageService.userVehicles();
    if (vehicles && vehicles.length > 0) {
      this.vehicle = vehicles.find((vehicle) => vehicle.vin == this.vin);
    }
  }

  getQuotation(schedule: IOpenSchedule) {
    this.getRemoteExperienceServiceID();
    this.quotationsService
      .getScheduleQuotation(
        schedule.advisorId.toString(),
        schedule.scheduleDate,
        schedule.scheduleHour.toString(),
        schedule.dealerId.toString(),
        schedule.country
      )
      .subscribe({
        next: (data) => {
          if (data.response && data.httpCode === HTTP_CODE.OK) {
            this.quotation = data.response;

            if (data.response.scheduleRecalls?.length) {
              this.recall = data.response.scheduleRecalls;
            }

            if (data.response?.customerWaitingInDealer === "Y") {
              this.customerWaitingInDealer = true;
            }

            this.quotation.requestedItems.services.forEach((service, index) => {
              service.promotionalPrice = service.discount != null ? (service.price - service.discount) : null;

              const isServiceRecall = this.isRecallService(service);

              if (service.serviceType == QUOTATION.SERVICE_TYPE_REVISION) {
                this.revisionInfo = service;
              }

              if (this.revisionInfo && 'price' in this.revisionInfo) {
                this.hasPriceInRevision = true;
              }

              if (service.serviceName.toLowerCase().includes((this.translate.instant('schedule.complementary-kit').toLowerCase()))) {
                this.iolm = service;
                this.iolmPrice = 0;
                this.iolm.revisionParts.forEach((service) => { this.iolmPrice += service.price })
                this.iolm.price = this.iolmPrice;
                this.quotation.requestedItems.services.splice(index, 1);
              }

              if (!service.price && service.price !== 0 && service.discount === null && !isServiceRecall) {
                this.onRequest = true;
              }

              if (service.serviceType == QUOTATION.SERVICE_TYPE_SERVICES && service.serviceId && service.serviceId !== this.remoteExeperienceServiceID && !isServiceRecall) {
                if (service !== this.iolm) {
                  this.services.push(service);
                }
              }

              if (service.serviceId === this.remoteExeperienceServiceID) {
                this.remoteExperienceService = service;
              }
            });
            this.getOfferedServices(this.schedule);
          }
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  isRecallService(service: QuotationService) {
    return isRecall(QUOTATION.SERVICE_TYPE_RECALL, service.serviceName)
  }

  getRemoteExperienceServiceID() {
    this.schedule.services.forEach(service => {
      if (service.pickupDelivery) {
        if (service.pickupDelivery.toUpperCase() === 'Y') {
          this.remoteExeperienceServiceID = service.serviceId;
        }
      }
      if (service.mobileService !== undefined) {
        if (service.mobileService.toUpperCase() === 'Y') {
          this.remoteExeperienceServiceID = service.serviceId;
        }
      }
    });
  }

  getOfferedServices(schedule: IOpenSchedule) {
    this.offeredServices = [];
    this.scheduleService
      .getOfferedServicesByDealer(schedule.dealerId.toString(), schedule.country || 'BRA')
      .subscribe({
        next: async (response) => {
          if (
            response.response &&
            response.response.length > 0 &&
            response.httpCode == HTTP_CODE.OK
          ) {
            response.response.forEach((service) => {
              if (this.revisionInfo &&
                service.serviceId == this.revisionInfo.serviceId) {
                this.revision = service;
              }
            });
            await this.getFordProtect();
          }
        },
        error: (error) => {
          this.sendErrorNotification(error);
        },
        complete: () => {
          this.removeRecallDeliveryFromList();

        }
      });
  }

  removeRecallDeliveryFromList() {
    const deliveryId = (this.remoteExperienceService) ? this.remoteExperienceService.serviceId : 0;
    for (let i = 0; i < this.services.length; i++) {
      if (
        this.services[i] !== undefined &&
        (this.services[i].serviceId == 24 ||
          this.services[i].serviceId == 240 ||
          this.services[i].serviceId == 426 ||
          this.services[i].serviceId == deliveryId)
      ) {
        if (this.services[i].serviceId == deliveryId) {
          this.delivery = this.services[i];
        }
        this.services.splice(i, 1);
      }
    }
    this.loading = false;
    this.calculateOptionalServicesPrice();
  }

  calculateOptionalServicesPrice() {
    let onRequest = 0;
    let noCost = 0;
    this.servicesTotalPrice = 0;
    this.services.forEach((service) => {
      // se TODOS os serviços forem sem custo, subtotal deve ser sem custo
      // se QUALQUER serviço for sob consulta, subtotal deve ser sob consulta
      if (service.isCostless && service.price == 0) {
        noCost += 1;
      } else if (!service.isCostless && service.price == 0 || service.price == null) {
        onRequest += 1;
      }

      if (service.discount !== null) {
        this.servicesHasPromotions = true;
      }

      this.servicesOriginalPrice += service.price;
      this.servicesSubTotal += service.subtotal;
    });
    this.servicesOnRequest = onRequest > 0 ? true : false;
    this.servicesNoCost = noCost ? true : false;

    this.getTotalPrice();
  }

  async getFordProtect() {
    this.loadingFP = true;
    this.getFordProtectCalled.emit();
    await new Promise((resolve) => {
      this.vehicleService.getFordProtect(this.vin).pipe(takeUntil(this.getFordProtectCalled))
        .subscribe({
          next: (response) => {
            if (response.httpCode === HTTP_CODE.OK && response.response) {
              this.fordProtect = response.response;
            }
            if (
              this.fordProtect &&
              this.fordProtect.contractList !== undefined &&
              this.fordProtect.contractList !== null &&
              this.fordProtect.contractList.length > 0
            ) {
              this.fordProtect.contractList = this.fordProtect.contractList.filter(
                (c) =>
                  c.productStatus.toLocaleLowerCase() ===
                  FORD_PROTECT_STATUS_ACTIVE ||
                  c.productStatus.toLocaleLowerCase() ===
                  FORD_PROTECT_STATUS_FINISHED
              );
              if (
                this.revision &&
                this.fordProtect.contractList.length > 0 &&
                this.isFordProtectValid()
              ) {
                this.calculateFordProtectDiscount();
                sessionStorage.setItem(
                  SESSION_FORD_PROTECT,
                  JSON.stringify(this.fordProtect)
                );
              } else {
                this.calculateRevisionTotalPrice();
              }
            } else if (this.revisionInfo !== undefined && this.revisionInfo !== null) {
              this.calculateRevisionTotalPrice();
            }
            resolve("Complete")
          },
          error: (error) => {
            console.error(error);
            this.loadingFP = false;
            this.calculateRevisionTotalPrice();
          },
          complete: () => {
            this.loadingFP = false;
          }
        });
    });

  }

  calculateFordProtectDiscount() {
    if (isFordProtectValid(this.fordProtect, this.revision.months)) {
      this.fordProtectPlanType = FordProtectPlanType.REVIEW_PLAN;
      this.hasFordProtect = true;
    } else {
      this.fordProtectPlanType = FordProtectPlanType.OTHER_PLANS;
    }
    this.calculateRevisionTotalPrice();
  }

  isFordProtectValid() {
    return isFordProtectValid(this.fordProtect, this.revision.months);
  }

  calculateRevisionTotalPrice() {
    this.revisionPrice = this.revisionInfo?.price + this.iolmPrice;
    if (this.hasFordProtect) {
      this.revisionPrice = 0;
    } else {
      if (this.revisionInfo?.campaigns && this.revisionInfo?.campaigns.length > 0) {
        this.revisionInfo.campaigns.forEach((campaign) => {
          this.revisionPrice = (this.revisionInfo?.price + this.iolmPrice) - this.generateDiscountValue(campaign, campaign.discountValueA, campaign.discountTypeC);
        });
      }
    }

    if (!this.hasFordProtect && this.revisionInfo?.discount === null && this.revisionPrice === 0) {
      this.onRequest = true;
    }

    this.loading = false;
    this.getTotalPrice();
  }

  generateCampaignName(
    campaignName: string,
    discountType: string,
    discountValue: number
  ): string {
    if (discountType === DISCOUNT_TYPE.PERCENTAGE) {
      return `${campaignName} (${discountValue}%)`;
    } else {
      return campaignName;
    }
  }

  generateDiscountValue(
    campaign: QuotationServiceCampaignModel,
    discountValue: number,
    discountType: string
  ): number {
    if (discountType === DISCOUNT_TYPE.PERCENTAGE) {
      let discountValueOfPerc =
        (campaign.discountValueA / 100) * (this.revisionInfo?.price + this.iolmPrice);
      if (discountValueOfPerc > 0) {
        discountValueOfPerc = Number(discountValueOfPerc.toFixed(2));
        if (
          Number(
            (Math.round(discountValueOfPerc / 1) * 1)
              .toString()
              .substr(discountValueOfPerc.toString().length - 1)
          ) === 5
        ) {
          discountValueOfPerc = Math.floor(discountValueOfPerc / 5) * 5 + 10;
        } else if (
          Number(
            (Math.round(discountValueOfPerc / 1) * 1)
              .toString()
              .substr(discountValueOfPerc.toString().length - 1)
          ) < 5
        ) {
          discountValueOfPerc = Math.floor(discountValueOfPerc / 5) * 5;
        } else if (
          Number(
            (Math.round(discountValueOfPerc / 1) * 1)
              .toString()
              .substr(discountValueOfPerc.toString().length - 1)
          ) > 5
        ) {
          discountValueOfPerc = (discountValueOfPerc / 5) * 5;
        }
      }
      return discountValueOfPerc;
    } else {
      return discountValue;
    }
  }

  getTotalPrice() {
    this.subTotal = 0;
    this.totalPrice = 0;

    if (this.iolm && !this.revisionInfo) {
      this.subTotal = this.iolmPrice;
      this.totalPrice += this.iolmPrice;
    }

    if (this.revisionInfo) {
      this.subTotal = this.revisionPrice;
      this.totalPrice += this.revisionPrice;
    }

    if (this.services) {
      this.services.forEach((service) => {
        if (service.discount && service.discount > 0) {
          this.subTotal += service.discount;
          this.totalPrice += service.price;
        } else {
          this.subTotal += service.price;
          this.totalPrice += service.price;
        }
      });
    }

    if (this.remoteExperienceService) {
      if (this.remoteExperienceService.discount !== null && this.remoteExperienceService.discount >= 0) {
        this.subTotal += this.remoteExperienceService.discount;
      } else {
        this.subTotal += this.remoteExperienceService.price;
      }
      this.totalPrice += this.remoteExperienceService.price;
    }

    this.#generateInfosFromTotalBox();
  }

  getUrlDriverImage(fileName: string) {
    this.scheduleService.getImageDriverSchedule(fileName)
      .subscribe((data) => {
        this.imageDriver = data;
      });
  }

  getFormattedHour(hour: number): string {
    return formatTime(hour);
  }

  closeDetails(value: boolean) {
    if (!this.isProjectStatus) {
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    }

    this.handleDetails.emit(value);
  }

  cancelSchedule(schedule: IOpenSchedule) {
    this.openModal = false;
    this.loadingCancel = true;
    this.performScheduleCancelation(schedule, false);
  }

  rescheduleChangeDate(schedule: IOpenSchedule) {
    this.loadingReschedule = true;
    this.performScheduleCancelation(schedule, true);
  }

  performScheduleCancelation(
    schedule: IOpenSchedule,
    reschedule: boolean
  ): void {
    if (reschedule) {
      this.scheduleService.goToSchedule(schedule, reschedule);
      return;
    }

    this.newScheduleService
      .delete(schedule, this.userProfile.userGuid ?? '', reschedule)
      .subscribe(
        {
          next: (data) => {
            if (data && 200 === data.httpCode) {
              sessionStorage.setItem('scheduleCanceled', schedule.scheduleId.toString());

              this.notification.add({
                text: this.translate.instant(
                  'schedule.cancel-schedule-confirmation'
                ),
                severity: 'SUCCESS',
                timeout: 5000,
              });
              // send push and email
              this.sendCancelMessage(schedule);
              this.loadingCancel = false;
              this.closeDetails(false);
            }
          },
          error: () => {
            this.loadingReschedule = false;
            this.notification.add({
              text: this.translate.instant('schedule.cancel-schedule-error'),
              severity: 'ERROR',
              timeout: 5000,
            });
          },
        }
      );
  }

  sendCancelMessage(schedule: IOpenSchedule) {
    this.pushService.send(schedule, TypeResourceMessage.CANCEL_SCHEDULE_PUSH, this.hasFordProtect);
  }

  #getFullAddress(address: string, city: string, state: string, postalCode: string | undefined, country: string): string {
    const validArguments = [];
    if (address && address.trim() !== '') {
      validArguments.push(address.trim());
    }
    if (city && city.trim() !== '') {
      validArguments.push(city.trim());
    }
    if (state && state.trim() !== '') {
      validArguments.push(state.trim());
    }
    if (postalCode && postalCode.trim() !== '' && country === COUNTRY_CODE.BRAZIL) {
      validArguments.push(postalCode.trim());
    }
    return validArguments.join(', ');
  }

  sendErrorNotification(error: any) {
    const text =
      this.translate.instant('status.evaluation.error') + ' ' + error.status;
    this.notification.add({
      text: text,
      severity: 'Error',
      timeout: 5000,
    });
  }

  openCancelModal(schedule: IOpenSchedule) {
    this.openModal = true;
    this.scheduleToCancel = schedule;
  }

  closeCancelModal() {
    this.openModal = false;
  }

  openRescheduleModal(schedule: IOpenSchedule) {
    this.scheduleToCancel = schedule;

    if (!this.canReschedule) {
      this.openRescheduleUnavailable = true;
      return;
    }

    this.openReschedule = true;
  }

  closeRescheduleModal() {
    this.openReschedule = false;
  }

  closeRescheduleUnavailableModal() {
    this.openRescheduleUnavailable = false;
  }

  public handlePudModal(): void {
    this.pudModal = !this.pudModal;
  }

  // TODO: remover a chamada do html
  getFormattedDate(scheduleDate: string) {
    const utcDate = new Date(scheduleDate);
    const formattedDate = `${utcDate.getUTCDate().toString().padStart(2, '0')}/${(utcDate.getUTCMonth() + 1).toString().padStart(2, '0')}/${utcDate.getUTCFullYear()}`;
    return `${formattedDate} (${this.translate.instant('weekdays.' + utcDate.getUTCDay().toString())})`;
  }

  //#region driver associated
  onHasDriverAssosiated(hasDriver: boolean) {
    this.hasDriverAssosiated = hasDriver;
  }
}
